import React from "react";
import Loader from "react-loader-spinner";
const LoaderSpinner = ({ type, text }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: 10,
        }}
      >
        <Loader type={"Circles"} color="grey" height={80} width={80} />
        <h2 style={{ marginLeft: 20, color: "grey" }}>{text && text}</h2>
      </div>
    </>
  );
};

export default LoaderSpinner;
